// home.js
import React from 'react';
import config from '../../../../config/config';
import CustomList from '../Util/List/CustomList/CustomList';
import CustomListContainer from '../Util/List/CustomList/CustomListContainer';
import { loadData } from '../Util/List/CustomList/loadData';
import { useSelector } from 'react-redux';

import '../home/Home.css';

function SynonymousDescriptions() {
    const sessionSelector = useSelector((state) => {
        return state.core.session;
    });
    const friendly_url = sessionSelector.pdc_project_friendly_url;

    const paths = {
        endpoint: config.endpoints.backend + 'portal/getallsynonymousdescriptions'
    };

    const list = {
        labelTitle: 'Cargos',
        icon: 'fa-file-role',
        filter: {
            friendly_url
        },
        columns: [
            {
                name: 'role',
                label: 'Cargo',
                width: '10%'
            },
            {
                name: 'cbo',
                label: 'Código CBO',
                width: '10%'
            },
            {
                name: 'synonymous',
                label: 'Sinônimo',
                width: '15%'
            },
            {
                name: 'description',
                label: 'Descrição',
                width: '50%'
            }
        ]
    };

    return (
        <div
            className="mt-3 mr-3"
            style={{
                marginLeft: '30px'
            }}
        >         
            <CustomListContainer
                canAdd={false}
                labelTitle={list.labelTitle}
                icon={list.icon}
                content={
                    <CustomList list={{ ...list, ...paths }} />
                }
            />
        </div>
    );
}

export default SynonymousDescriptions;
